import { render, staticRenderFns } from "./UserPassport.vue?vue&type=template&id=67b73db5&scoped=true&"
import script from "./UserPassport.vue?vue&type=script&lang=js&"
export * from "./UserPassport.vue?vue&type=script&lang=js&"
import style0 from "./UserPassport.vue?vue&type=style&index=0&id=67b73db5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b73db5",
  null
  
)

export default component.exports